export default () => {
  for (const element of document.querySelectorAll(".accordion__button")) {
    element.addEventListener("click", (event) => {
      // Wait for bootstrap accordion transistion to complete before scrolling to get the correct target location
      setTimeout(() => {
        event.target.closest('.accordion__item').scrollIntoView()
      }, 300)
    });
  }
}
